import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Video URLs for different routes (using placeholder videos for testing)
const VIDEO_URLS = {
  'invoice_create': 'https://s3.twcstorage.ru/8a6e091b-publick/invoice1123.mp4',
  'invoice_calculate': 'https://s3.twcstorage.ru/8a6e091b-publick/calculation123.mp4',
  'template_create': 'https://s3.twcstorage.ru/8a6e091b-publick/template123.mp4',
  'template_edit': 'https://s3.twcstorage.ru/8a6e091b-publick/template123.mp4',
  'claim_create': 'https://s3.twcstorage.ru/8a6e091b-publick/claims123.mp4',
  'tracking': 'https://s3.twcstorage.ru/8a6e091b-publick/tracking123.mp4',
  // Видео для этапов авторизации
  'auth_login': 'https://s3.twcstorage.ru/8a6e091b-publick/auth_client.mp4',
  'auth_contact': 'https://s3.twcstorage.ru/8a6e091b-publick/auth_client.mp4',
};

// Route configurations - titleKey/descriptionKey are i18n keys from the 'basic' namespace
const ROUTE_CONFIGS = {
  '/invoice': {
    type: 'invoice_create',
    titleKey: 'creating_invoice',
    descriptionKey: 'desc_create_invoice',
  },
  '/invoice_calculation': {
    type: 'invoice_calculate',
    titleKey: 'calculating_cost',
    descriptionKey: 'desc_calculate_cost',
  },
  '/template': {
    type: 'template_create',
    titleKey: 'creating_template',
    descriptionKey: 'desc_create_template',
  },
  '/template_update': {
    type: 'template_edit',
    titleKey: 'editing_template',
    descriptionKey: 'desc_edit_template',
  },
  '/pretense': {
    type: 'claim_create',
    titleKey: 'creating_claim',
    descriptionKey: 'desc_create_claim',
  },
  '/tracking_start': {
    type: 'tracking',
    titleKey: 'tracking_cargo',
    descriptionKey: 'desc_tracking',
  },
  '/auth': {
    type: 'auth_login',
    titleKey: 'auth_login',
    descriptionKey: 'desc_auth',
  },
  '/auth_contact': {
    type: 'auth_contact',
    titleKey: 'auth_contact',
    descriptionKey: 'desc_auth_contact',
  },
};

// Helper function to get route config by path
export const getRouteConfig = (path) => {
  return ROUTE_CONFIGS[path];
};

// Helper function to get video URL by route type
export const getVideoUrl = (routeType) => {
  return VIDEO_URLS[routeType];
};

export const useFirstTimeModal = () => {
  const location = useLocation();
  const [modalState, setModalState] = useState({
    isOpen: false,
    routeType: null,
    videoUrl: null,
    titleKey: '',
    descriptionKey: '',
  });

  useEffect(() => {
    const currentPath = location.pathname;
    const routeConfig =
      ROUTE_CONFIGS[currentPath] ||
      (currentPath.startsWith('/template_update/') ? ROUTE_CONFIGS['/template_update'] : undefined);

    if (routeConfig) {
      const storageKey = `firstTime_${routeConfig.type}`;
      const hasSeenBefore = localStorage.getItem(storageKey);

      if (!hasSeenBefore) {
        setModalState({
          isOpen: true,
          routeType: routeConfig.type,
          videoUrl: VIDEO_URLS[routeConfig.type],
          titleKey: routeConfig.titleKey,
          descriptionKey: routeConfig.descriptionKey,
        });
      }
    }
  }, [location.pathname]);

  const closeModal = () => {
    setModalState(prev => ({
      ...prev,
      isOpen: false,
    }));
  };

  const resetFirstTimeState = (routeType) => {
    if (routeType) {
      localStorage.removeItem(`firstTime_${routeType}`);
    }
  };

  const setFirstTimeSeen = (routeType) => {
    if (routeType) {
      localStorage.setItem(`firstTime_${routeType}`, 'true');
    }
  };

  return {
    modalState,
    closeModal,
    resetFirstTimeState,
    setFirstTimeSeen,
  };
};

// Hook for manual modal control
export const useManualModal = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const getModalProps = () => {
    const routeConfig = getRouteConfig(location.pathname);
    if (!routeConfig) return null;

    return {
      isOpen,
      onClose: closeModal,
      routeType: routeConfig.type,
      videoUrl: getVideoUrl(routeConfig.type),
      titleKey: routeConfig.titleKey,
      descriptionKey: routeConfig.descriptionKey,
      forceShow: true,
    };
  };

  return {
    isOpen,
    openModal,
    closeModal,
    getModalProps,
  };
}; 